import React, {Component} from 'react';
import Popup from "../../../components/popup";

import { ButtonCancel, ButtonProceed, ButtonReturn } from '../../../components/buttons';

import PopupContext from '../../../context/context-popup';
import Container from '../../../layouts/containers/container';
import InputsTextarea from '../../../components/inputs/inputs-text-area';

import List from '../../../components/list';
import meetingsApi from '../../../lib/meetings/meetings-api';
import alertManager from '../../../managers/alert/alert-manager';
import LabelContainer from '../../../components/label-container';
import ErrorContainer from '../../../components/error-container';
import Cross from '../../../components/buttons/cross';
import dayjs from 'dayjs';

import isBetween from 'dayjs/plugin/isBetween';

import humanizeDuration from 'humanize-duration';
import eventsApi from '../../../lib/events/events-api';

dayjs.extend(isBetween)

export default class PopupsCancelBooking extends Component {
    static contextType = PopupContext;

    constructor(props) {
        super(props);

        this.state = {
            quote: {},
            errors: {},
        };
    }

    componentDidMount() {
        eventsApi.getBookingQuoteCancellation(this.props.event.id, this.props.booking.id, this.props.booking).then((data) => {
            this.setState({ quote: data })
        });
    }

    update() {
        eventsApi.cancelBooking(this.props.event.id, this.props.booking.id, (errors) => {
            this.setState({ errors })
        }).then(() => {
            window.location.href = `/mydmc/events/${this.props.event.id}/bookings/${this.props.booking.id}`
        })
    }

    render() {
        const { closePopup } = this.context;
        const errors = Object.values(this.state.errors).flat();

        const pre_mins = this.props.event?.pre_event_charged_period_mins || 0;

        const dateWithinToBeCharged = dayjs(this.props?.booking?.start).subtract(pre_mins, 'minute');
    
        const shouldBeCharged = dayjs().isBetween(dayjs(dateWithinToBeCharged), dayjs(this.props?.booking?.start));
    
        const hours = pre_mins / 60;
        const milliseconds = pre_mins * 60000;
    
        const duration = hours > 48 ? humanizeDuration(milliseconds) : humanizeDuration(milliseconds, {
            units: ['h']
        })

        return (
            <Popup className="booking-cancel">
                <Popup.Content>
                    <Container.Text fontSize="30px" color="#151515">
                        Are you sure you wish to cancel Booking: <Container.Text color="#1577EA" span> #{ this.props.booking.id }</Container.Text>
                    </Container.Text>

                    <ErrorContainer errors={errors}>
                        <List gap="20px">
                            { shouldBeCharged &&
                                <>
                                    <LabelContainer label={<Container.Text fontSize="16px" color="#929BA8">Charges Applicable</Container.Text>}>
                                        <List gap="10px">
                                            <Container.Text style={{ whiteSpace: 'pre-line' }} html={`
                                                You will still be charged if you proceed with cancelling this booking.

                                                Your cancellation request is within the <b>${duration}</b> window before the time of booking. 
                                                
                                                The amount charged will be: £${this.state.quote?.total} + ${this.state.quote?.total_credits_used} Credits
                                                
                                                Upcoming transaction information: 
                                                
                                                BACS: Your scheduled invoice will be sent via the Barnsley MBC SAP payment system and BACS payment is required. Failure to process this payment will result in further action.
                                            `}></Container.Text>
                                        </List>
                                    </LabelContainer>

                                    <Container.Text fontSize="16px" color="#929BA8">Charges can be overridden by super admins if required.</Container.Text>
                                </>
                            }
                            
                            <Container.Text fontSize="16px" color="#151515">
                                Once you confirm to proceed, this booking will be cancelled and non-returnable. If payments are due and suppliers have services to provide, the MGMT team must update third-party records where applicable 
                            </Container.Text>
                        </List>
                    </ErrorContainer>
                </Popup.Content>

                <Popup.Buttons>
                    <ButtonProceed onClick={this.update.bind(this)} color="red">Confirm Cancellation</ButtonProceed>
                    <ButtonReturn onClick={closePopup} rightIcon={<Cross/>}>Return To Booking</ButtonReturn>
                    <ButtonProceed>Contact us to discuss</ButtonProceed>
                </Popup.Buttons>
            </Popup>
        );
    }
}
